import React from "react";
import { Badge } from "@/components/ui/badge";
import { RCA_SEVERITY, RCA_STATUS } from "@/lib/rca";

export function SeverityBadge({ sev }) {
  const s = RCA_SEVERITY[sev] || RCA_SEVERITY.SEV3;
  return <Badge variant="outline" className={`h-5 px-1.5 text-[10px] font-bold ${s.chip}`} data-testid={`sev-${sev}`}>{s.short}</Badge>;
}

export function RcaStatusBadge({ status }) {
  const s = RCA_STATUS[status] || RCA_STATUS.draft;
  return <Badge variant="outline" className={`h-5 px-1.5 text-[10px] uppercase tracking-wide ${s.chip}`} data-testid={`rca-status-${status}`}>{s.label}</Badge>;
}

export function Field({ label, hint, children, className = "" }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <label className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</label>
      {children}
      {hint && <p className="text-[11px] text-slate-400">{hint}</p>}
    </div>
  );
}

export function Section({ n, title, desc, children, testid }) {
  return (
    <section className="bg-white border border-slate-200 rounded-xl p-5 sm:p-6" data-testid={testid}>
      <div className="flex items-start gap-3 mb-5">
        <span className="w-7 h-7 rounded-lg bg-indigo-50 text-indigo-600 text-xs font-bold flex items-center justify-center shrink-0">{n}</span>
        <div>
          <h2 className="font-display font-semibold text-slate-900">{title}</h2>
          {desc && <p className="text-xs text-slate-500 mt-0.5">{desc}</p>}
        </div>
      </div>
      {children}
    </section>
  );
}
